var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.success
      ? _c("div", [
          _vm._v("\n    " + _vm._s(_vm.$t("signup-success")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.success === false
      ? _c("div", [
          _vm._v("\n    " + _vm._s(_vm.$t("signup-unsuccessful")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.success
      ? _c(
          "div",
          [
            _c(
              "b-form",
              {
                on: {
                  submit: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.signUp.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "b-form-group",
                  [
                    _c("b-form-input", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("login.email")
                      },
                      model: {
                        value: _vm.form.email,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "mt-4",
                      attrs: {
                        type: "password",
                        placeholder: _vm.$t("login.password")
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100 mt-4",
                        attrs: { variant: "primary", type: "submit" }
                      },
                      [_vm._v(_vm._s(_vm.$t("continue-with-certificate")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-274dcbb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-274dcbb2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/account/SignUpCertificate.vue
// module id = 3737
// module chunks = 112